import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Col, Row } from 'antd';
import Box from 'ui-box';

const shouldNavigateOnTheAdditionalPage = (path, userAnswer) =>
  path && userAnswer === true;

function MobileFeedBackNavBtn({
  fieldName,
  isFirst,
  isLast,
  prevRoutePath,
  nextRoutePath,
  additionalRoute,
}) {
  const { t } = useTranslation();
  const history = useHistory();

  const { values, submitForm } = useFormikContext();
  // console.log('values', values);

  const value = values[fieldName];

  const onPrev = () => {
    history.push(prevRoutePath);
  };

  const onNext = () => {
    if (isLast && !shouldNavigateOnTheAdditionalPage(additionalRoute, value)) {
      submitForm();
    } else if (shouldNavigateOnTheAdditionalPage(additionalRoute, value)) {
      history.push(additionalRoute);
    } else {
      history.push(nextRoutePath);
    }
    // else if (shouldNavigateOnTheRecommendedGreenPage(recommendedRoute, values)) {
    //   submitForm();
    // }

  };
  let isDisabled = true;
  if (Array.isArray(value)) {
    isDisabled = value.length;
  } else if (typeof value === 'string') {
    isDisabled = value;
  } else if (typeof value === 'number') {
    isDisabled = value >= 0;
  } else if (typeof value === 'boolean') {
    isDisabled = true
  }

  return (
    <Box
      position="absolute"
      bottom="50px"
      marginLeft="auto"
      marginRight="auto"
      left="0"
      right="0"
      width="100%"
      maxWidth="480px"
      paddingX={20}
    >
      <Box marginBottom={12}>
        {
          !isFirst && (
            <Col xs={24}>
              <Button
                htmlType="button"
                type="primary"
                size="large"
                onClick={onPrev}
                block
                ghost
              >
                {t(`common:button.previous`)}
              </Button>
            </Col>
          )
        }
      </Box>
      <Box gutter={16}>
        <Col xs={24}>
          <Button
            htmlType="button"
            type="primary"
            size="large"
            onClick={onNext}
            disabled={!isDisabled}
            block
          >
            {isLast ? t(`common:button.finish`) : t(`common:button.next`)}
          </Button>
        </Col>
      </Box>
    </Box>
  );
}

MobileFeedBackNavBtn.defaultProps = {
  isLast: false,
  isFirst: false
};

const { string, bool } = PropTypes;

MobileFeedBackNavBtn.propTypes = {
  fieldName: string.isRequired,
  isFirst: bool,
  isLast: bool,
  prevRoutePath: string.isRequired,
  nextRoutePath: string.isRequired,
};

export default MobileFeedBackNavBtn;
